"use strict";

require("core-js/modules/es.weak-map.js");

require("core-js/modules/web.dom-collections.iterator.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _components = require("~components");

var styles = _interopRequireWildcard(require("./styles.module.scss"));

function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}

function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || typeof obj !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache(nodeInterop);

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
/** ============================================================================
 * Slice
 */


var LinkGrid = function LinkGrid(_ref) {
  var id = _ref.id,
      className = _ref.className,
      linkGridItems = _ref.data.linkGridItems;
  return /*#__PURE__*/_react.default.createElement("section", {
    sliceid: id,
    className: [className, styles.container].join(" ")
  }, /*#__PURE__*/_react.default.createElement("ul", {
    className: styles.grid
  }, linkGridItems.map(function (_ref2) {
    var background = _ref2.backgroundColor,
        color = _ref2.fontColor,
        disabled = _ref2.disabled,
        link = _ref2.link,
        heading = _ref2.heading,
        subheading = _ref2.subheading,
        backgroundImage = _ref2.backgroundImage;
    var itemClassName = [styles.gridItem, // styles[`gridItem${size}`],
    styles.gridItemM, disabled ? styles.gridItemDisabled : ""].join(" ");
    return /*#__PURE__*/_react.default.createElement("li", {
      key: "link-grid-".concat(heading),
      style: {
        background: (background === null || background === void 0 ? void 0 : background.hex) || "white",
        color: (color === null || color === void 0 ? void 0 : color.hex) || "black"
      },
      className: itemClassName
    }, backgroundImage && /*#__PURE__*/_react.default.createElement("figure", {
      className: [styles.gridItemBackground]
    }, /*#__PURE__*/_react.default.createElement(_components.Image, {
      image: backgroundImage
    })), /*#__PURE__*/_react.default.createElement(_components.Link, {
      to: link.url
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: styles.gridItemContent
    }, /*#__PURE__*/_react.default.createElement("header", null, subheading && /*#__PURE__*/_react.default.createElement("h3", {
      className: "b2"
    }, subheading), /*#__PURE__*/_react.default.createElement("h2", {
      className: "b1"
    }, heading)), /*#__PURE__*/_react.default.createElement("p", {
      className: "button-text"
    }, link.text))));
  })));
};

var _default = LinkGrid;
exports.default = _default;